import * as React from "react"
import { Typeahead, AsyncTypeahead } from "react-bootstrap-typeahead"
import { Button, Form } from "react-bootstrap"
import { FaAngleDown } from "react-icons/fa"
import AutoFilterCompany from "../../api/Companies/CompanyModel/AutoFilterCompany"
import { concat, of, Subject, Subscription } from "rxjs"
import { catchError, debounceTime, filter, map, switchMap } from "rxjs/operators"
import { DataLoader } from "../OrderRequests/GovCollection"
import GetAccountsByNameObservable from "../../api/Companies/GetAccountsByName"
import { RouteComponentProps, withRouter } from "react-router"
import { WorkforceClinicPortal } from "../../AppState"
import { AccountType } from "../../config/Constants"

interface AccountInputState {
  accounts: DataLoader<AutoFilterCompany>
}

interface AccountInputProps {
  defaultValue?: string
  forceEdit?: boolean
  id?: string
  disabled?: boolean
  filter?: boolean
  placeholder?: string
  emptyLabel?: string
  accountType: AccountType
  onChange?: (items: AutoFilterCompany[]) => void
}

class AccountInput extends React.PureComponent<AccountInputProps & RouteComponentProps, AccountInputState> {
  accountAsyncTypeahead = React.createRef<AsyncTypeahead<AutoFilterCompany>>()
  accountTypeahead = React.createRef<Typeahead<AutoFilterCompany>>()
  accounts$ = new Subject<string>()
  subscription?: Subscription
  state: AccountInputState = { accounts: {} }
  defaultAccountName: string = this.props.defaultValue || this.getAccountName()

  componentDidMount() {
    this.subcribeAccounts()
    this.onInputChange(this.defaultAccountName)
  }

  componentDidUpdate(prevProps: AccountInputProps & RouteComponentProps, prevState: AccountInputState) {
    if ((this.props.accountType !== prevProps.accountType) || !this.defaultAccountName && this.props.location.pathname !== prevProps.location.pathname) {
      this.accountAsyncTypeahead?.current?.clear()
      this.onInputChange("")
    }
  }

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
  }

  onInputChange(value: string) {
    if (value === "") {
      this.setState({ accounts: { selected: undefined } }, () => this.props.onChange && this.props.onChange([]))
    }
    else {
      this.accounts$.next(value)
    }
  }

  getAccountName() {

    const participation = sessionStorage.getItem("company-selection")
    const portals: WorkforceClinicPortal[] = JSON.parse(sessionStorage.getItem("wf2-STRY0045127-portals") || "{}")
    var account = undefined
    for (const p of portals) {
      for (const c of p.AssignedClientDetailsOfClinic) {
        if (c.ParticipationID.toString() == participation) {
          account = c
          break
        }
      }
      if (account) {
        break
      }
    }
    return account?.Name || ""
  }

  onChange = (accounts: AutoFilterCompany[]) => {
    this.setState({ accounts: { ...this.state.accounts, selected: accounts[0] } })
    this.props.onChange && this.props.onChange(accounts)
  }

  subcribeAccounts() {
    this.subscription = this.accounts$.pipe(
      debounceTime(500),
      filter(filter => filter.length >= 1 || filter.length === 0),
      switchMap((filter) => filter.length === 0 ?
        of({ loading: false, accounts: this.state.accounts.data }) :
        concat(
          of({ loading: true }),
          GetAccountsByNameObservable(filter, undefined, this.props.accountType).pipe(
            map((data) => ({ loading: false, accounts: data })),
            catchError(() => of({ loading: false }))
          )
        )
      )
    ).subscribe(
      (state: { loading: boolean, accounts?: AutoFilterCompany[] }) => {
        state.accounts ?
          this.setState({ accounts: { loading: state.loading, data: state.accounts, selected: this.defaultAccountName ? state.accounts[0] : undefined } }, () => this.defaultAccountName && this.onChange((state.accounts || []))) :
          this.setState({ accounts: { loading: state.loading } })
      },
      () => this.setState({ accounts: { loading: false } })
    )
  }

  render() {
    return (
      <>
        {(!this.defaultAccountName || this.props.forceEdit) ? <AsyncTypeahead
          useCache={false}
          disabled={this.props.disabled}
          emptyLabel={this.props.emptyLabel || "No " + AccountType[this.props.accountType] + " Found"}
          filterBy={(option, props) => this.props.filter ? props.selected.length > 0 || option.Name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1 : true}
          id={this.props.id || AccountType[this.props.accountType]}
          isLoading={!!this.state.accounts.loading}
          labelKey="Name"
          minLength={0}
          onInputChange={input => this.onInputChange(input)}
          onChange={items => this.onChange(items)}
          onSearch={() => { }}
          options={this.state.accounts.data || []}
          placeholder={this.props.placeholder || "Enter the " + AccountType[this.props.accountType] + " name"}
          ref={this.accountAsyncTypeahead}
          selected={this.state.accounts.selected ? [this.state.accounts.selected] : []}>
          {!this.state.accounts.loading && !this.props.disabled &&
            <Button variant="toggle" onClick={() => { this.accountAsyncTypeahead?.current?.toggleMenu() }}>
              <FaAngleDown />
            </Button>}
        </AsyncTypeahead> : <Form.Control type="text" disabled defaultValue={this.state.accounts.selected?.Name || ""} />}
      </>
    )
  }
}

export default withRouter(AccountInput)
